import { useEffect, useState } from "react"
import { connect } from "react-redux"
import { useParams, useSearchParams } from "react-router-dom"
import { bindActionCreators } from "redux"
import { callCompanySelectGet } from "../../actions/companies"
import { callUserCompanyListGet, callUserCompanyPost, callUserCompanyDelete } from "../../actions/user-companies"
import Swal from 'sweetalert2'
import TableView from "../../../../common/containers/TableView"

let UserCompany = ({ setPageAttr, methods: { callUserCompanyListGet, callUserCompanyPost, callUserCompanyDelete, callCompanySelectGet }, list, companiesSelect }) => {
    const params = useParams()
    const [userId] = useState(!params.userId ? '' : params.userId)
    let [searchParams] = useSearchParams();
    const [companyId, setCompanyId] = useState('')

    const remove = (id) => {
        Swal.fire({
            title: 'Tem certeza que deseja deletar? Essa ação não poderá ser desfeita!',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Sim',
            denyButtonText: `Não`,
        }).then((result) => {
            if (result.isConfirmed) {
                callUserCompanyDelete(userId, id, () => {
                    let pg = searchParams.get('pg')
                    pg = pg ? pg : 1
                    callUserCompanyListGet(userId, {}, pg)
                })
            }
        })
    }

    useEffect(() => {
        callCompanySelectGet()
        let tabs = [
            {
                active: false,
                to: '/users',
                label: 'Informações'
            },
            {
                active: false,
                to: '/users/edit/' + userId,
                label: 'Editar'
            },
            {
                active: true,
                to: '/users/companies/' + userId,
                label: 'Empresas'
            },
            {
                active: false,
                to: '/users/regions/' + userId,
                label: 'Regiões'
            }
        ]

        setPageAttr({
            title: 'Usuário - Empresa - Editar',
            caption: 'Preencha os campos para inserir as informações',
            btns: [],
            tabs: tabs
        })
    }, [setPageAttr, userId, callCompanySelectGet])

    useEffect(() => {
        let pg = searchParams.get('pg')
        pg = pg ? pg : 1
        callUserCompanyListGet(userId, {}, pg)
    }, [callUserCompanyListGet, searchParams, userId])

    const finishedSubmit = () => {
        setCompanyId('')
        
        let pg = searchParams.get('pg')
        pg = pg ? pg : 1
        callUserCompanyListGet(userId, {}, pg)
    }

    const submit = (e) => {
        e.preventDefault()

        let data = {
            companyId: parseInt(companyId)
        }
        callUserCompanyPost(userId, data, () => finishedSubmit())
    }

    const headers = [
        {
            type: 'info',
            name: 'company',
            align: 'left',
            label: 'Empresa'
        },
        {
            type: 'info',
            name: 'author',
            align: 'left',
            label: 'Criado por'
        },
        {
            type: 'custom',
            align: 'right',
            label: 'Opções',
            custom: (a) => {
                return (
                    <>
                        <span className='btn btn-sm btn-danger ml-2' onClick={() => remove(a.id)}><i className='fas fa-trash'></i></span>
                    </>
                )
            }
        }
    ]

    return (
        <form onSubmit={submit}>
            <div className="form-row">
                <div className="col-md-4 form-group">
                    <label className="required">Empresa:</label>
                    <select className="form-control" value={companyId} onChange={e => setCompanyId(e.target.value)}>
                        <option value=''>Selecione</option>
                        {companiesSelect.map((a, ai) => (
                            <option key={ai} value={a.id}>{a.description}</option>
                        ))}
                    </select>
                </div>
                <div className="col-md-2">
                    <label>&nbsp;</label><br />
                    <button className="btn btn-primary" type="submit"><i className="mr-1 fas fa-plus fa-white"></i>Adicionar</button>
                </div>
            </div>
            <div className="mt-3">
                <TableView headers={headers} rows={list.rows} total={list.total} pagination={list.pagination} paginationTo={'/users/companies/' + userId} />
            </div>
        </form>
    )
}

const mapStateToProps = ({ register: { userCompanies: { list }, companies } }) => ({
    list: list,
    companiesSelect: companies.select
});

const mapDispatchToProps = (dispatch) => ({
    methods: bindActionCreators(
        {
            callUserCompanyListGet,
            callUserCompanyPost,
            callUserCompanyDelete,
            callCompanySelectGet
        },
        dispatch
    )
});

export default connect(mapStateToProps, mapDispatchToProps)(UserCompany)